import { gql } from "@apollo/client";

export const CREATE_TENANT_MUTATION = gql`
  mutation Createtenant(
    $alias: String!
    $subscriptionId: ID
    $subscriptionName: String
    $regions: [String!]
    $subRegions: [String!]
    $description: String
    $defaultUnit: String
  ) {
    createTenant(
      alias: $alias
      subscriptionId: $subscriptionId
      subscriptionName: $subscriptionName
      regions: $regions
      subRegions: $subRegions
      description: $description
      defaultUnit: $defaultUnit
    )
  }
`;

export const UPDATE_TENANT_MUTATION = gql`
  mutation Updatetenant($tenantId: ID!, $tenantInfoInput: TenantInfoInput!) {
    updateTenant(id: $tenantId, tenant: $tenantInfoInput)
  }
`;

export const DELETE_TENANT_MUTATION = gql`
  mutation DeletetenantById($tenantId: ID!) {
    deleteTenantById(tenantId: $tenantId)
  }
`;

export const CREATE_USERS_MUTATION = gql`
  mutation CreateUsers($usersDataInput: [UserDataInput!]!) {
    createUsers(usersDataInput: $usersDataInput)
  }
`;

export const EDIT_USER_MUTATION = gql`
  mutation EditUser($editUserInput: EditUserInput!) {
    editUser(editUserInput: $editUserInput)
  }
`;

export const DELETE_USER_MUTATION = gql`
  mutation DeleteUser($targetEmail: AWSEmail!) {
    deleteUser(targetEmail: $targetEmail)
  }
`;

export const CREATE_MEASUREMENT_TECHNOLOGY_MUTATION = gql`
  mutation CreateMeasurementTechnology($measurementTechnology: MeasurementTechnologyCreate!) {
    createMeasurementTechnology(measurementTechnology: $measurementTechnology) {
      id
      name
    }
  }
`;

export const UPDATE_MEASUREMENT_TECHNOLOGY_MUTATION = gql`
  mutation UpdateMeasurementTechnology($id: ID!, $measurementTechnology: MeasurementTechnologyUpdate!) {
    updateMeasurementTechnology(id: $id, measurementTechnology: $measurementTechnology) {
      id
      name
    }
  }
`;

export const DELETE_MEASUREMENT_TECHNOLOGY_MUTATION = gql`
  mutation DeleteMeasurementTechnology($id: ID!) {
    deleteMeasurementTechnology(id: $id)
  }
`;

export const CREATE_PROJECT_GROUP_MUTATION = gql`
  mutation CreateProjectGroup($tenantId: ID, $projectGroup: ProjectGroupInput!) {
    createProjectGroup(tenantId: $tenantId, projectGroup: $projectGroup)
  }
`;

export const UPDATE_PROJECT_GROUP_MUTATION = gql`
  mutation UpdateProjectGroup($projectGroupId: ID!, $projectGroup: ProjectGroupInput!) {
    updateProjectGroup(projectGroupId: $projectGroupId, projectGroup: $projectGroup)
  }
`;

export const DELETE_PROJECT_GROUP_MUTATION = gql`
  mutation DeleteProjectGroup($projectGroupId: ID!) {
    deleteProjectGroup(projectGroupId: $projectGroupId)
  }
`;

export const CREATE_GROUP_VERSION_MUTATION = gql`
  mutation CreateProjectGroup($groupVersionInput: GroupVersionInput) {
    createGroupVersion(groupVersionInput: $groupVersionInput)
  }
`;

export const UPDATE_GROUP_VERSION_MUTATION = gql`
  mutation UpdateGroupVersion($id: ID!, $groupVersionInput: GroupVersionInput) {
    updateGroupVersion(id: $id, groupVersionInput: $groupVersionInput)
  }
`;

export const DELETE_GROUP_VERSION_MUTATION = gql`
  mutation DeleteGroupVersion($id: ID!) {
    deleteGroupVersion(id: $id)
  }
`;

export const CREATE_GROUP_VERSION_OGMP_CATEGORY_MUTATION = gql`
  mutation CreateGroupVersionOgmpCategory($versionCategoryInput: GroupVersionOGMPCategoryCreateInput!) {
    createGroupVersionOGMPCategory(versionCategoryInput: $versionCategoryInput) {
      id
    }
  }
`;

export const UPDATE_GROUP_VERSION_OGMP_CATEGORY_MUTATION = gql`
  mutation UpdateGroupVersionOgmpCategory($versionCategoryInput: GroupVersionOGMPCategoryUpdateInput!) {
    updateGroupVersionOGMPCategory(versionCategoryInput: $versionCategoryInput)
  }
`;

export const DELETE_GROUP_VERSION_OGMP_CATEGORY_MUTATION = gql`
  mutation DeleteGroupVersionOgmpCategory($groupVersionId: ID!, $ogmpCategoryId: ID!) {
    deleteGroupVersionOGMPCategory(groupVersionId: $groupVersionId, ogmpCategoryId: $ogmpCategoryId)
  }
`;
export const CREATE_SITE_MEASUREMENT = gql`
  mutation CreateSiteMeasurement($tenantId: ID!, $siteMeasurementInput: SiteMeasurementInput) {
    createSiteMeasurement(tenantId: $tenantId, siteMeasurementInput: $siteMeasurementInput)
  }
`;
export const UPDATE_SITE_MEASUREMENT = gql`
  mutation UpdateSiteMeasurement($tenantId: ID!, $id: ID!, $siteMeasurementInput: SiteMeasurementInput) {
    updateSiteMeasurement(tenantId: $tenantId, id: $id, siteMeasurementInput: $siteMeasurementInput)
  }
`;
export const DELETE_SITE_MEASUREMENT = gql`
  mutation DeleteSiteMeasurement($id: ID!) {
    deleteSiteMeasurement(id: $id)
  }
`;
export const COPY_TENANT_CONFIGURATION_MUTATION = gql`
  mutation CopyTenantConfiguration($sourceTenantId: ID!, $targetTenantId: ID!) {
    copyTenantConfiguration(sourceTenantId: $sourceTenantId, targetTenantId: $targetTenantId)
  }
`;

export const TRIGGER_FLAT_TABLE_REFRESH = gql`
  mutation TriggerFlatTableRefresh {
    triggerFlatTableRefresh {
      taskStatus
      taskId
      message
      error
    }
  }
`;

export const UPDATE_TENANT_DISPLAY_FEATURES = gql`
  mutation UpdateTenantDisplayFeatures($tenantId: ID!, $features: [DisplayFeatureToggleInput!]!, $resetToDefault: Boolean!) {
    updateTenantDisplayFeatures(tenantId: $tenantId, features: $features, resetToDefault: $resetToDefault) {
      tenantId
      usesDefault
      items {
        path
        name
        depth
        enabled
        defaultEnabled
        hasChildren
      }
    }
  }
`;

export const BULK_TOGGLE_TENANT_DISPLAY_FEATURE = gql`
  mutation BulkToggleTenantDisplayFeature($tenantIds: [ID!]!, $features: [DisplayFeatureToggleInput!]!) {
    bulkToggleTenantDisplayFeature(tenantIds: $tenantIds, features: $features) {
      updatedCount
      failedTenantIds
    }
  }
`;
